/* Card wishlist heart (setting card_wishlist_heart, BG-186). Growave draws the heart inside the open shadow root of each
   .gw-add-to-wishlist-product-card-placeholder; this restyles it to a flat heart, mirrors its count as 1.2k beside it, and
   shows the (initially hidden) .pcard-wish wrapper only once Growave's button exists. Toggling stays Growave's own button. */
(function () {
  'use strict';

  var HOST = '.gw-add-to-wishlist-product-card-placeholder';
  var BTN = '.gw-toggle-wishlist-product-card-button';
  var CNT = '.gw-toggle-wishlist-product-card-button__counter';
  var CSS =
    BTN + '{background:transparent!important;box-shadow:none!important;border-radius:6px!important;width:24px!important;height:24px!important}' +
    BTN + ' .gw-wl-icon{width:16px!important;height:16px!important;color:#63605a!important}' +
    BTN + '[data-in-wishlist="true"] .gw-wl-icon{color:var(--price-color,#a82c17)!important}' +
    BTN + '[data-in-wishlist="true"] .gw-wl-icon path{fill:var(--price-color,#a82c17)!important;stroke:var(--price-color,#a82c17)!important}' +
    BTN + ':focus-visible{outline:2px solid #2a2b2a!important;outline-offset:-2px!important}' +
    CNT + '{display:none!important}' +
    '.pcw-desc{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}';

  function abbr(t) {
    var n = /^\d+$/.test(t) ? +t : NaN;
    if (isNaN(n) || n < 1000) return t;
    return (n < 10000 ? (Math.floor(n / 100) / 10).toFixed(1).replace(/\.0$/, '') : Math.floor(n / 1000)) + 'k';
  }

  function sync(wrap, root) {
    var btn = root.querySelector(BTN);
    if (!btn) { // Growave removed its button: hide the wrapper until it returns
      wrap.hidden = true;
      wrap.removeAttribute('data-ready');
      wrap.classList.remove('is-saved');
      wrap.querySelector('.pcard-wish__n').textContent = '';
      return;
    }
    if (!wrap.hasAttribute('data-ready')) { setup(wrap); return; }
    var cnt = root.querySelector(CNT);
    var raw = cnt ? cnt.textContent.trim() : '';
    set(wrap.querySelector('.pcard-wish__n'), abbr(raw));
    wrap.classList.toggle('is-saved', btn.getAttribute('data-in-wishlist') === 'true');
    // The visible count is aria-hidden: give the one real control the full count as its description.
    var d = root.querySelector('.pcw-desc');
    if (!d) {
      d = document.createElement('span');
      d.className = 'pcw-desc';
      d.id = 'pcw-desc';
      root.appendChild(d);
    }
    set(d, raw ? 'Saved by ' + raw + (raw === '1' ? ' person' : ' people') : '');
    var pressed = btn.getAttribute('data-in-wishlist') === 'true' ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
    if (btn.getAttribute('aria-describedby') !== 'pcw-desc') btn.setAttribute('aria-describedby', 'pcw-desc');
  }

  function set(el, text) { if (el.textContent !== text) el.textContent = text; } // no write = no mutation loop

  function setup(wrap) {
    var host = wrap.querySelector(HOST);
    var root = host && host.shadowRoot;
    if (!root || !root.querySelector(BTN)) return false;
    if (!root.querySelector('style[data-pcw]')) {
      var style = document.createElement('style');
      style.setAttribute('data-pcw', '');
      style.textContent = CSS;
      root.appendChild(style);
    }
    if (wrap._pcwMo) wrap._pcwMo.disconnect();
    wrap._pcwMo = new MutationObserver(function () { sync(wrap, root); });
    wrap._pcwMo.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-in-wishlist'] });
    wrap.setAttribute('data-ready', '');
    wrap.hidden = false;
    sync(wrap, root);
    return true;
  }

  var timer = 0;
  var stopAt = 0;

  // Finds wrappers (also those added later by Load more / filtering) and sets up each as soon as Growave has drawn its button.
  function scan() {
    var pending = 0;
    var wraps = document.querySelectorAll('.pcard-wish:not([data-ready])');
    for (var i = 0; i < wraps.length; i++) if (!setup(wraps[i])) pending++;
    if (!pending || Date.now() > stopAt) { clearInterval(timer); timer = 0; }
  }

  function wake() {
    stopAt = Date.now() + 20000;
    if (!timer) timer = setInterval(scan, 400);
  }

  // The count beside the heart toggles the same Growave button.
  document.addEventListener('click', function (e) {
    var n = e.target.closest && e.target.closest('.pcard-wish__n');
    if (!n) return;
    var host = n.parentNode.querySelector(HOST);
    var btn = host && host.shadowRoot && host.shadowRoot.querySelector(BTN);
    if (btn) btn.click();
  });

  function start() {
    var debounce = 0;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('.pcard-wish') || n.querySelector('.pcard-wish'))) {
            clearTimeout(debounce);
            debounce = setTimeout(function () { wake(); scan(); }, 100);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    wake();
    scan();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
